import * as THREE from 'three'

// Estilo de apresentação: fundo em degradê (céu claro em cima, quase
// branco junto ao chão) e luz de hemisfério em vez da luz ambiente
// plana. Serve para imagens e vídeos para terceiros; o fundo liso
// continua a ser o normal de trabalho.
//
// O degradê é uma textura de fundo da cena, por isso fica preso ao
// ecrã e não roda com a câmara. A luz de hemisfério dá às faces
// viradas para cima um tom mais frio e às viradas para baixo um tom
// mais quente, o que separa melhor as faces do que a ambiente.

const NOME_HEMISFERIO = 'vn2r.apresentacao.hemisferio'

let textura: THREE.CanvasTexture | null = null
const ambienteOriginal = new WeakMap<THREE.AmbientLight, number>()

function texturaDoDegrade(): THREE.CanvasTexture {
  if (textura) return textura
  const cv = document.createElement('canvas')
  cv.width = 4
  cv.height = 512
  const g = cv.getContext('2d')!
  const gr = g.createLinearGradient(0, 0, 0, 512)
  gr.addColorStop(0, '#8E9AAB')
  gr.addColorStop(0.55, '#C9D0DA')
  gr.addColorStop(1, '#F3F5F8')
  g.fillStyle = gr
  g.fillRect(0, 0, 4, 512)
  textura = new THREE.CanvasTexture(cv)
  textura.colorSpace = THREE.SRGBColorSpace
  return textura
}

export function corDoFundoLiso(bgMode: 'dark' | 'light'): string {
  return bgMode === 'light' ? '#cbd5e1' : '#1c1d24'
}

/** Liga ou desliga o estilo de apresentação na cena. Desligado, repõe o
 *  fundo liso do modo actual e a luz ambiente que lá estava. */
export function aplicarEstiloApresentacao(
  scene: THREE.Scene,
  ligado: boolean,
  bgMode: 'dark' | 'light',
): void {
  scene.background = ligado ? texturaDoDegrade() : new THREE.Color(corDoFundoLiso(bgMode))

  // A luz fica sempre na cena e só muda a intensidade. Acrescentar ou
  // tirar uma luz obriga o three a recompilar os shaders de todos os
  // materiais, e com os modelos do Fragments isso prende a página.
  let hemi = scene.getObjectByName(NOME_HEMISFERIO) as THREE.HemisphereLight | undefined
  if (!hemi) {
    hemi = new THREE.HemisphereLight(0xdfe8f5, 0x8a8170, 0)
    hemi.name = NOME_HEMISFERIO
    scene.add(hemi)
  }
  hemi.intensity = ligado ? 0.75 : 0

  scene.traverse((o) => {
    if (!(o instanceof THREE.AmbientLight)) return
    if (!ambienteOriginal.has(o)) ambienteOriginal.set(o, o.intensity)
    const base = ambienteOriginal.get(o)!
    o.intensity = ligado ? base * 0.35 : base
  })
}
